import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  AfterViewInit,
  Input,
  OnDestroy,
} from '@angular/core';
import { NavigationService, WindowRefService } from 'i2g-ng-utils';
import {
  I2gNgTrackingActionBuilder,
  I2gNgTrackingService,
} from 'i2g-ng-tracking';
// import { I2gMoneyOnboardingTrackingBuilder } from '../../builders/onboarding-tracking.builder';
import { map, take, takeUntil } from 'rxjs/operators';
import { I2gDialogService, IconSizesEnum, IIcon } from 'i2g-ng-ui';
import { AccountDataStore } from '../../../account-data/account-data.store';
import { Observable, Subject } from 'rxjs';
import { SettingsDataDispatcher } from '../../../settings-data/settings-data.dispatcher';
import { SetPhoneDialogComponent } from '../../../settings/components/set-phone-dialog/set-phone-dialog.component';
// eslint-disable-next-line max-len
import { I2gMoneyOnboardingDialogComponent } from '../../../shared/components/payments/i2g-money-onboarding-dialog/i2g-money-onboarding-dialog.component';

@Component({
  selector: 'app-onboarding-i2g-money-dialog',
  templateUrl: './onboarding-i2g-money-dialog.component.html',
  styleUrls: ['./onboarding-i2g-money-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingI2gMoneyDialogComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() trackingScreenName: string;

  _windowRef: Window;

  onboardingIcon: IIcon = {
    name: 'money-onboarding',
    size: IconSizesEnum.custom,
  };

  userPhoneNumber$: Observable<string>;

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _windowRefService: WindowRefService,
    private _navigationService: NavigationService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingService: I2gNgTrackingService, // private _trackingBuilder: I2gMoneyOnboardingTrackingBuilder,
    private _accountStore: AccountDataStore,
    private _settingsDataDispatcher: SettingsDataDispatcher,
    private _dialogService: I2gDialogService
  ) {}

  ngOnInit() {
    this._windowRef = this._windowRefService.nativeWindow;

    this.userPhoneNumber$ = this._accountStore.getUser().pipe(
      takeUntil(this._destroyed),
      map((user) => user?.phoneNumber)
    );
  }

  ngAfterViewInit() {
    // tracking
    // this._trackingService.trackEvent(
    //   this._trackingBuilder.buildOnboarding(this.basicDetails.platform),
    //   this._trackingActionBuilder.buildPresented(this.basicDetails.origin)
    // );
  }

  cancelApplication() {
    //   this._windowRef.parent.postMessage(CLOSE_I2G_MONEY_ONBOARDING, '*');
    //   // tracking
    //   this._trackingService.trackEvent(
    //     this._trackingBuilder.buildOnboarding(this.basicDetails.platform),
    //     this._trackingActionBuilder.buildButtonTapped(
    //       'dismiss',
    //       this.basicDetails.origin
    //     )
    //   );
  }

  learnMore() {
    // tracking
    // this._trackingService.trackEvent(
    //   this._trackingBuilder.buildOnboarding(this.basicDetails.platform),
    //   this._trackingActionBuilder.buildButtonTapped(
    //     'learn_more',
    //     this.basicDetails.origin
    //   )
    // );
  }

  setupNow() {
    this.userPhoneNumber$.pipe(take(1)).subscribe((phoneNumber) => {
      if (phoneNumber) {
        const phoneNumberLengthAndCodeAreFromUS =
          phoneNumber.length === 12 && phoneNumber.startsWith('+1');

        // US phone numbers start with digits 2-9 but not 1 or 0
        const firstDigit = phoneNumber.replace('+1', '').charAt(0);
        const firstDigitIsCorrect = firstDigit !== '0' && firstDigit !== '1';

        if (phoneNumberLengthAndCodeAreFromUS && firstDigitIsCorrect) {
          // user can directly go to KYB/KYC form
          this._dialogService.openDialog(I2gMoneyOnboardingDialogComponent, {
            trackingScreenName: this.trackingScreenName,
            isDismissible: true,
            fullScreen: true,
          });
        } else {
          // need to tell user that they need to add a US phone number
          console.log('need a US phone number');
        }
      } else {
        this._dialogService.openDialog(SetPhoneDialogComponent, {
          title: 'DIALOG.PAYMENTS.I2G_MONEY.2FA.TITLE',
          body: 'DIALOG.PAYMENTS.I2G_MONEY.2FA.DESCRIPTION',
          allowCountryChange: false,
          defaultCountry: 'US',
          phoneNumberPattern: /^\d{10}$/, // comes from Unit docs
        });
      }
    });
    // void this._navigationService.goTo(this.applicationRoute);
    // tracking
    // this._trackingService.trackEvent(
    //   this._trackingBuilder.buildOnboarding(this.basicDetails.platform),
    //   this._trackingActionBuilder.buildButtonTapped(
    //     'setup_now',
    //     this.basicDetails.origin
    //   )
    // );
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
